<template lang="pug">
  .rodape.clearfix
    hr.-full
    a.back(v-on:click="historyBack")
      i.fa.fa-reply(aria-hidden="true") &nbsp;&nbsp;&nbsp;
      | Voltar
    //- .addthis_inline_share_toolbox
    a.share(href="http://www.addthis.com/bookmark.php?v=300&pubid=ra-5a2eeaa74ba9d7fe" target="_blank" noopener)
      | Compartilhar &nbsp;&nbsp;&nbsp;
      i.zmdi.zmdi-share(aria-hidden="true")
</template>

<style lang="scss">
  .rodape {
    color: inherit;

    > a {
      color: inherit;
      display: inline-block;
      margin: 11px 0;
      cursor: pointer;
      > i { color: inherit }
      &:focus, &:hover {
        color: $color-blue-dark;
        text-decoration: none;
      }
    }

    > .back { float: left }
    > .share { float: right }

    @include media("print") {
      display: none;
    }
  }
</style>

<script>
  export default {
    name: 'back-and-share',
    methods: {
      historyBack: function (event) {
        window.history.back()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// BackAndShare.vue?50d7463d